<template>

    <lu-hbox lu-flex-wrap lu-hcenter class='card-header pad-in-5' >
      <lu-hbox lu-vcenter  >
        <FontIcon v-if='!isLessThanMinWidth' @click='onExpand' lu-click type='material-icons' name='keyboard_arrow_up' class='icon' style='margin-right: 5px;'  :class="isExpanded ? 'isActive' : ''" />
        <lu-item  class='title' style='margin-right: 10px;' :class="resizeFont('title')">{{ $t(options.title) }}</lu-item>
        <lu-item  v-if='options.lotsMios && currencySelected && isMios && isParamSymbol' :class="resizeFont('title')"> ( {{ currencySelected }} )</lu-item>
        <lu-item  v-if='(options.lotsMios && isParamSymbol && !isMios) || panelId === "Reconciliation"' :class="resizeFont('title')"> ( LOTS )</lu-item>
        <lu-item>
          <el-radio-group text-color="#FFFFFF" fill="#409EFF" size="small" v-if='panelId === "BookPnL" || panelId === "BookPnL1" || panelId === "BookPnL2" || panelId === "STPPnL" || panelId === "BookAggregation"' :value='getBookPnLModeLabel' @change='onChangeBookPnLMode'>
            <el-radio-button label="PnL"></el-radio-button>
            <el-radio-button label="Exposure"></el-radio-button>
          </el-radio-group>
        </lu-item>

        <lu-item lu-flex v-if='(panelId === "BookPnL" || panelId === "BookPnL1" || panelId === "BookPnL2" || panelId === "STPPnL" || panelId === "BookAggregation") &&  getBookPnLMode' style='margin-left:40px;' >
          <el-switch :value='getLotsMios'
            active-value='mios' inactive-value='lots'
            :active-text='$t("Mio")' :inactive-text='$t("Lots")' @change='onChangeLotsMios'
          />
        </lu-item>

        <lu-item lu-vcenter lu-flex v-if='panelId === "BookPnL" || panelId === "BookPnL1" || panelId === "BookPnL2"' :style='getBookSetStyle(panelId)'>{{ $t('BookSet') }}</lu-item>
        <lu-item lu-vcenter lu-flex v-if='panelId === "BookPnL" || panelId === "BookPnL1" || panelId === "BookPnL2"'  style='margin-left:10px; width: 80px;' >
          <el-select :placeholder="$t('BookSet')" filterable :value='getBookSet' @change='onChangeBookSet'>
            <el-option
              v-for="bs in bookSetList"
              :key="bs.bookSet"
              :label="bs.bookName"
              :value="bs.bookSet">
            </el-option>
          </el-select>
        </lu-item>
      </lu-hbox>

      <lu-item v-if='panelId === "BookPnL"'>
        <el-button @click.stop="onChangeShowNetExposure">{{ isShowNetExposure ? $t('Hide Net Exposure') : $t('Show Net Exposure') }}</el-button>
      </lu-item>
      <slot name='totalSlot'/>

      <div>
        <el-tooltip class="item" :effect="styleTooltip" :content="formatToolTip(value)" placement="top" :disabled="disableToolTip(value)">
          <el-cascader
            placeholder="Book"
            v-model="value"
            :options="bookList"
            clearable :appendToBody="false" :filter-method="filterMethod" filterable v-if='showBookFilter' :show-all-levels="false" @change="changeBookFilter" style="width: 120px"></el-cascader>
        </el-tooltip>
      </div>

      <lu-hbox lu-rflex class='pad-in-5' v-if='!isLessThanMinWidth' >
        <el-tooltip class="item" :effect="styleTooltip" :content="$t(optionExpand)" placement="top">
          <lu-item :class='getLimitIcon' lu-click style='smargin-top:5px;font-size:1.5em;' @click.stop='onSelectedNoLimitPanel'></lu-item>
        </el-tooltip>
        <el-tooltip class="item" :effect="styleTooltip" :content="$t('Export Excel')" placement="top">
          <lu-item class='el-icon-download' lu-click style='margin-top:5px;' @click.stop='onExportExcel'></lu-item>
        </el-tooltip>
        <el-tooltip class="item" :effect="styleTooltip" :content="$t('Settings')" placement="top" v-if='$scopedSlots.options'>
          <lu-item lu-click v-if='noPopup' class='el-icon-s-tools' style='margin-top:5px;' @click="$emit('settings')"></lu-item>
          <el-popover v-else
            placement="top"
            trigger="click">
              <slot name='options'></slot>
              <lu-item slot="reference" >
                <lu-item class='el-icon-s-tools' lu-click style='margin-top:5px;'></lu-item>
              </lu-item>
          </el-popover>
        </el-tooltip>

        <el-tooltip v-if='!riskFullScreen' class="item" :effect="styleTooltip" :content="$t('Full screen')" placement="top">
          <lu-item class='el-icon-full-screen' lu-click style='margin-top:5px;' @click.stop='onFullScreen'></lu-item>
        </el-tooltip>

        <el-tooltip class="item" :effect="styleTooltip" :content="$t('Close')" placement="top">
          <lu-item class='el-icon-close' lu-click style='margin-top:5px;' @click.stop='onClose'></lu-item>
        </el-tooltip>
      </lu-hbox>
    </lu-hbox>
</template>

<script>
import { LuHbox, LuItem } from 'lusis-ui'
import FontIcon from '@/components/FontIcon'
import utilsMixin from '@/mixins/utils'
// import SettingsLot from './settingsLot'
import { mapState, mapGetters } from 'vuex'
import screenfull from 'screenfull'

export default {
  name: 'SettingsPanel',
  components: { LuHbox, LuItem, FontIcon },
  props: {
    options: {
      type: Object,
      default: function() {
        return {
        }
      }
    },
    noPopup: {
      type: Boolean,
      default: false
    },
    dataExposureTotal: {
      type: Object,
      default: function() {
        return {
        }
      }
    },
    panelId: {
      type: String
    }
  },
  mixins: [ utilsMixin ],
  data: function () {
    return {
      isExpanded: false,
      clicked: false,
      value: []
    }
  },
  computed: {
    ...mapState({
      riskFullScreen: state => state.app.riskFullScreen,
      currencySelected: state => state.settingsMonitor.settingParams.currency,
      changeGrouping: state => state.settingsMonitor.settingParams.changeGrouping,
      panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    ...mapGetters([ 'theme', 'bookList', 'bookSetList' ]),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    isMios: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return tmp.options.lotsMios && tmp.options.lotsMios === 'mios'
    },
    isParamSymbol: function () {
      let tmp = this.changeGrouping[this.options.groupKey]
      let tmpObj = null
      if (tmp === undefined || tmp === null) {
        tmpObj = this.panelConfig.find(item => item.id === this.panelId)
        tmp = tmpObj.options.defaultMapping
      }
      return tmp && tmp === 'symbol'
    },
    isLessThanMinWidth: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      let minWidth = tmp.options.minWidth ? tmp.options.minWidth : 220
      return tmp.options.width <= minWidth
    },
    optionExpand () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return typeof tmp.options.noLimit && tmp.options.noLimit ? this.$t('Contract') : this.$t('Expand')
    },
    getLimitIcon () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return typeof tmp.options.noLimit && tmp.options.noLimit ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
    },
    showBookFilter () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return !!tmp.options.showBookFilter
    },
    getBookFilterId: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return tmp.bookFilterId
    },
    getBookPnLModeLabel () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return tmp.options.bookPnLMode ? this.$t('Exposure') : this.$t('PnL')
    },
    getBookPnLMode: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return tmp.options.bookPnLMode ? 1 : 0
    },
    getLotsMios: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return !!tmp.options.lotsMios && tmp.options.lotsMios === 'lots' ? 'lots' : 'mios'
    },
    getBookSet: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return tmp.options.bookSet
    },
    isShowNetExposure () {
      let tmp = this.panelConfig.find(item => item.id === this.panelId)
      return tmp.options.showNetExposure || false
    }
  },
  methods: {
    onClose: function () {
      if (this.riskFullScreen) {
        screenfull.toggle().then(() => {
          this.$store.dispatch('app/toggleRiskFullScreen', screenfull.isFullscreen)
        })
      }
      else {
        this.$emit('close')
      }
    },
    onExpand: function () {
      this.isExpanded = !this.isExpanded
      this.$emit('expand', this.isExpanded)
    },
    onFullScreen: function () {
      this.$emit('fullscreen')
    },
    onExportExcel: function () {
      this.$emit('exportexcel')
    },
    onSelectedNoLimitPanel: function () {
      this.$emit('selectedNoLimitPanel')
    },
    onChangeBookPnLMode: function () {
      this.$emit('changeBookPnLMode')
    },
    onChangeLotsMios: function () {
      this.$emit('changeLotsMios')
    },
    onChangeBookSet: function (bookSet) {
      this.$emit('changeBookSet', bookSet)
    },
    onChangeShowNetExposure: function () {
      this.$emit('changeShowNetExposure')
    },
    changeBookFilter(value) {
      let bookFilterId = this.getBookFilterId

      if (bookFilterId === '' || bookFilterId === undefined || bookFilterId === null)
        return

      let platform = value[0] === undefined || value[0] === null ? "" : value[0]
      let bookName = value[1] === undefined || value[1] === null ? "" : value[1]

      this.$emit('changeBookFilter', bookFilterId, platform, bookName)
    },
    formatToolTip: function (value) {
      if (this.getBookFilterIsValid(value))
        return value[0] + ' / ' + value[1]
      else
        return ''
    },
    disableToolTip: function (value) {
      return !this.getBookFilterIsValid(value)
    },
    getBookFilterIsValid(value) {
      return !(value[0]===undefined || value[0]===null || value[1]===undefined || value[1]===null ||(value[0]==="" && value[1]===""))
    },
    filterMethod(node, keyword) {
      const { text } = node;
      return text.toLowerCase().includes(keyword.toLowerCase());
    },
    getBookSetStyle: function (panelId) {
      if (panelId === 'BookPnL') {
        return 'margin-left:40px'
      }
      return 'margin-left:15px'
    }
  }
}
</script>

<style lang='scss'>
  .app-container .el-input {
    .el-input__inner {
      width: 100% !important;
      //width: 120px;
      //max-width: 50%;
    }
  }
</style>